import React, { useState, useEffect } from "react";

import "./style.scss";

const InputField = ({
  id,
  value,
  label,
  name,
  placeholder,
  type,
  onChange,
  handleOnBlur,
  handleKeyUp,
  fieldClasses,
  errorMsg,
  helpMsg,
  isRequired,
  disabled,
  defaultValue,
  wordCountMax,
  rows,
  image,
  refVal,
  maxLength,
  input_label,
  errStyle,
  helpStyle,
  inputMode,
}) => {
  const [wordCountCurrent, setWordCountCurrent] = useState(0);
  const handleWordCount = (event) => {
    const textCount = event.target.value.length;

    if (textCount > wordCountMax) {
      event.target.value = event.target.value.substring(0, wordCountMax);
      return false;
    } else {
      setWordCountCurrent(event.target.value.length);
    }
  };

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.target.type === "number") {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const onBlur = (event, value) => {
    if (handleOnBlur) {
      handleOnBlur(event, value);
    }
  };

  const onKeyUp = (event) => {
    if (handleKeyUp) {
      handleKeyUp(event);
    }

    if (wordCountMax) {
      handleWordCount(event);
    }
  };
  return type && type != "textarea" ? (
    <div className={"form-group custom-input" + (maxLength == 4 ? " parentNumStyle" : "")}>
      {label && (
        <label htmlFor={id} className={input_label ? "input_label" : "label_class"}>
          {label}
          {isRequired && <span className="required">*</span>}
        </label>
      )}
      <input
        id={id}
        type={type}
        value={value}
        name={name}
        ref={refVal}
        className={
          fieldClasses + (errorMsg && errorMsg !== "" ? " error-field" : "") + (image ? " padding-input-img" : "")
        }
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        defaultValue={defaultValue}
        maxLength={maxLength}
        onBlur={onBlur}
        inputMode={inputMode}
      />
      {image && <img src={image} alt="input icon" className="input-img" />}
      <span className={`error-etext error-${errStyle}`}>{errorMsg}</span>
      <span className={`help-etext help-${helpStyle}`}>{helpMsg}</span>
    </div>
  ) : (
    <>
      {label ? (
        <label htmlFor={id}>
          {label}
          {wordCountMax ? (
            <span className="wordcount">
              {wordCountCurrent}/{wordCountMax}
            </span>
          ) : (
            ""
          )}
        </label>
      ) : (
        ""
      )}
      <textarea
        className={fieldClasses}
        id={id}
        rows={rows}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
      />
    </>
  );
};

export default InputField;
